import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

export const Skeleton: FC<{ className?: string }> = ({ className }): ReactNode => {
    return <div className={cn('animate-pulse rounded-lg bg-slate-200/70', className)} aria-hidden='true' />
}

/* Shown for the split second it takes to read saved data on the device. */
export const PageSkeleton: FC<{ rows?: number }> = ({ rows = 4 }): ReactNode => {
    return (
        <div className='space-y-4' role='status' aria-label='Loading'>
            <div className='grid grid-cols-2 gap-3 md:grid-cols-4'>
                {Array.from({ length: 4 }, (_, index) => <Skeleton key={index} className='h-24 rounded-xl' />)}
            </div>

            {Array.from({ length: rows }, (_, index) => <Skeleton key={index} className='h-28 rounded-xl' />)}
        </div>
    )
}
